export default "__VITE_ASSET__BUp$fD6i__"